import { render, staticRenderFns } from "./JettonTabHistory.vue?vue&type=template&id=61033168&scoped=true"
import script from "./JettonTabHistory.vue?vue&type=script&lang=js"
export * from "./JettonTabHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61033168",
  null
  
)

export default component.exports